import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setMessage, setWait } from "../../redux";
import "./style.css";

function Meeting() {
    const [meetings, setMeetings] = useState([]);
    const [invitations, setInvitations] = useState([]);
    const user = useSelector(state => state.profil);

    useEffect(() => {
        fetchMeetings();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const fetchMeetings = async () => {
        const token = sessionStorage.getItem("token");

        const req = await fetch(`${process.env.REACT_APP_API_URL}/meeting/me/upcoming`, {
            headers: { Authorization: `Bearer ${token}` }
        });

        const res = await req.json();
        console.log(res);
        

        // réunions confirmées
        const confirmed = res.filter(m =>
            m.owner === user._id ||
            m.participants.some(p => p.user === user._id && p.status === "accepted")
        );

        // invitations
        const pending = res.filter(m =>
            m.participants.some(p => p.user === user._id && p.status === "pending")
        );

        setMeetings(confirmed);
        setInvitations(pending);
    };

    return (
        <div className="page_meeting">
            <CreateMeeting onCreated={fetchMeetings} />

            <UpcomingMeetings
                meetings={meetings}
                onUpdate={fetchMeetings}
            />

            <Invitations
                invitations={invitations}
                onUpdate={fetchMeetings}
            />

        </div>
    );
}

function CreateMeeting({ onCreated }) {
    const dispatch = useDispatch();
    const [participants, setParticipants] = useState([]);
    const [description, setDescription] = useState("");
    const [date, setDate] = useState("");

    const [search, setSearch] = useState("");
    const [users, setUsers] = useState([]);

    useEffect(() => {
        fetchUsers();
    }, []);

    const fetchUsers = async () => {
        const token = sessionStorage.getItem("token");

        const req = await fetch(`${process.env.REACT_APP_API_URL}/users/get`, {
            headers: { Authorization: `Bearer ${token}` }
        });

        const res = await req.json();
        setUsers(res);
    };

    const filteredUsers = users.filter(user => {
        const s = search.toLowerCase();

        return (
            user.lastName?.toLowerCase().includes(s) ||
            user.firstName?.toLowerCase().includes(s) ||
            user.profession?.toLowerCase().includes(s) ||
            user.mainLocation?.toLowerCase().includes(s)
        );
    });

    const toggleParticipant = (userId) => {
        if (participants.includes(userId)) {
            setParticipants(participants.filter(id => id !== userId));
        } else {
            setParticipants([...participants, userId]);
        }
    };

    const createMeeting = async () => {
        const token = sessionStorage.getItem("token");

        const [d, t] = date.split("T");
        const [year, month, day] = d.split("-").map(Number);
        const [hour, minute] = t.split(":").map(Number);

        const localDate = new Date(year, month - 1, day, hour, minute);

        dispatch(setWait(1));
        const req = await fetch(`${process.env.REACT_APP_API_URL}/meeting/create`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify({
                participants,
                description,
                scheduledAt: localDate.toISOString()
            })
        });
        const res = await req.json();
        dispatch(setWait(-1));

        if (req.status !== 201) {
            dispatch(setMessage(res.message));
            setTimeout(() => dispatch(setMessage()), 2000);
            return
        }

        setParticipants([]);
        setDescription("");
        setDate("");
        onCreated();
    };

    return (
        <div className="block">
            <h2>Créer une réunion</h2>

            <div className="inp_field">
                <label>Date</label>
                <input
                    type="datetime-local"
                    value={date}
                    onChange={e => setDate(e.target.value)}
                />
            </div>

            <div className="inp_field">
                <label>Description</label>
                <input
                    placeholder="Motif de la réunion"
                    value={description}
                    onChange={e => setDescription(e.target.value)}
                />
                <span className="exemple">Ne pas mettre de nom de patient mais des initiales (ex: "Besoin de parler RF trouble psy" ou "Enfant LH violence familiale possible").</span>
            </div>

            <div className="inp_field">
                <label>Rechercher des participants</label>
                <input
                    placeholder="Nom, prénom..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                />
            </div>

            <ul className="list_users">
                {filteredUsers.map(user => {
                    const isSelected = participants.includes(user._id);

                    return (
                        <li
                            key={user._id}
                            className={isSelected ? "selected" : ""}
                            onClick={() => toggleParticipant(user._id)}
                        >
                            <p><span>{user.profession}</span></p>
                            <p>{user.lastName} {user.firstName}</p>
                            <p>{user.mainLocation}</p>
                        </li>
                    );
                })}
            </ul>

            {participants.length > 0 && (
                <div className="list_block">
                    <label>Participants sélectionnés</label>
                    <ul>
                        {participants.map(id => {
                            const user = users.find(u => u._id === id);
                            if (!user) return null;

                            return (
                                <li key={id}>
                                    <button
                                        className="participant_tag"
                                        onClick={() => toggleParticipant(id)}
                                    >
                                        <span className="name">
                                            {user.lastName} {user.firstName}
                                        </span>
                                        <span className="remove">✕</span>
                                    </button>
                                </li>
                            );
                        })}
                    </ul>
                </div>
            )}

            <button className="btn_create" onClick={createMeeting}>
                Créer
            </button>

            <p className="alert">
                <span>ATTENTION :</span> <br />
                - Créer une réunion en visio fait de vous l'hôte de la réunion. <br />
                - Personne ne pourra rejoindre la réunion si l'hôte ne la rejoint pas au préalable. <br />
                - L'hôte est également rédacteur (par défaut) et donc responsable du compte rendu de la réunion.
            </p>
        </div>
    );
}

function UpcomingMeetings({ meetings, onUpdate }) {
    const dispatch = useDispatch();
    const [data, setData] = useState([]);
    const [historical, setHistorical] = useState(false);
    const user = useSelector(state => state.profil);

    useEffect(() => {
        if (!meetings) {
            setData([]);
            return;
        }

        const newData = meetings.filter(meet =>
            meet.status === 'pending' || meet.status === 'active'
        );

        const historicalData = meetings.filter(meet =>
            meet.status === 'finished' || meet.status === 'cancelled'
        );

        // optionnel : trier
        newData.sort((a, b) => new Date(a.scheduledAt) - new Date(b.scheduledAt));
        historicalData.sort((a, b) => new Date(b.scheduledAt) - new Date(a.scheduledAt));

        setData(historical ? historicalData : newData);

    }, [meetings, historical]);

    const joinMeeting = (meeting) => {
        const now = Date.now();
        const meetingTime = new Date(meeting.scheduledAt).getTime();

        if (now < meetingTime) {
            alert("La réunion n'a pas encore commencé");
            return;
        }

        window.open(meeting.meetingLink, "_blank");
    };

    const cancelMeeting = async (id) => {
        const token = sessionStorage.getItem("token");

        dispatch(setWait(1));
        const req = await fetch(`${process.env.REACT_APP_API_URL}/meeting/cancel`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify({ meetingId: id })
        });
        const res = await req.json();
        dispatch(setWait(-1));

        if (req.status !== 200) {
            dispatch(setMessage(res.message));
            setTimeout(() => dispatch(setMessage()), 2000);
            return
        }

        onUpdate();
    };

    const finishMeeting = async (id) => {
        const token = sessionStorage.getItem("token");

        dispatch(setWait(1));
        const req = await fetch(`${process.env.REACT_APP_API_URL}/meeting/finish`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify({ meetingId: id })
        });
        const res = await req.json();
        dispatch(setWait(-1));

        if (req.status !== 200) {
            dispatch(setMessage(res.message));
            setTimeout(() => dispatch(setMessage()), 2000);
            return
        }

        onUpdate();
    };

    const now = new Date();

    return (
        <div className="block">
            <h2>Mes réunions</h2>

            <div className="choose_panel">
                <button className={!historical ? 'actif' : ''} onClick={() => setHistorical(false)}>À venir</button> |
                <button className={historical ? 'actif' : ''} onClick={() => setHistorical(true)}>Historique</button>
            </div>

            {data.map(m => {
                const isStarted = now >= new Date(m.scheduledAt);
                const isOwner = m.owner === user._id;

                return (
                    <div key={m._id} className="card">

                        <p>{m.description}</p>
                        <p>{new Date(m.scheduledAt).toLocaleString()}</p>

                        {!historical &&
                            <div className="panel">
                                <button className="btn-blue" onClick={() => joinMeeting(m)}>
                                    Rejoindre
                                </button>

                                {/* 👇 seulement si owner */}
                                {isOwner && (
                                    <div className="actions">
                                        {isStarted ? (
                                            <button
                                                className="btn-finish"
                                                onClick={() => finishMeeting(m._id)}
                                            >
                                                Terminer
                                            </button>
                                        ) : (
                                            <button
                                                className="btn-cancel"
                                                onClick={() => cancelMeeting(m._id)}
                                            >
                                                Annuler
                                            </button>
                                        )}
                                    </div>
                                )}
                            </div>
                        }
                    </div>
                );
            })}

        </div>
    );
}

function Invitations({ invitations, onUpdate }) {

    const respond = async (meetingId, response) => {
        const token = sessionStorage.getItem("token");

        await fetch(`${process.env.REACT_APP_API_URL}/meeting/respond`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify({ meetingId, response })
        });

        onUpdate();
    };

    return (
        <div className="block">
            <h2>Invitations</h2>

            {invitations.map(m => (
                <div key={m._id} className="card">

                    <p>{m.description}</p>
                    <p>{new Date(m.scheduledAt).toLocaleString()}</p>

                    <div className="panel">
                        <button onClick={() => respond(m._id, "refused")}>
                            Refuser
                        </button>

                        <button className="btn-blue" onClick={() => respond(m._id, "accepted")}>
                            Accepter
                        </button>
                    </div>
                </div>
            ))}
        </div>
    );
}

export default Meeting;